import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { form_control, UserEdit } from "projects/sepidz-web-framework/src/lib/models";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { takeUntil } from "rxjs/operators";
import { LookupItem } from "projects/sepidz-web-framework/src/lib/models/lookup-item.model";
import { UserBranch } from "projects/sepidz-web-framework/src/lib/models/user-branch.model";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { UserRole } from "projects/sepidz-web-framework/src/lib/models/user-role.model";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { ValidatorFn, Validators } from "@angular/forms";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { DataCenterProcess } from "../../data-center-process/data-center-process.model";
import { CheckBrachAccessModel } from "../../data-center-process/chek-branch-access.model";
import { SoftWareLicenseKind } from "projects/sepidz-web-framework/src/lib/models/license-information.model";

@Component({
  selector: "ngx-user-form",
  templateUrl: "./user-form.component.html",
  styleUrls: ["./user-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserFormComponent extends BaseFormComponent<UserEdit> {
  haserror: boolean = false;
  erroremessage: string;
  isOk4View: boolean = false;
  roles: number[] = [];
  hasRialDiscount: number;
  hasPercentDiscount: number;
  rolesIsLodes: boolean = false;
  isAccessToAllBranches = true;
  DefaultValues: Dictionary = [];
  Branches: form_control[];
  deactivateSave: boolean = false;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
    this.FillData();
  }
  async ngOnInit() {
    this.apiName = "Authorization";
    this.label = this.translate("ClientApp.GNR.User.DefineUser");
    super.ngOnInit();
    this.DefaultValues["ApplicationUserId"] = 0;
    this.setValue("rialDiscount", "");
    this.setValue("percentDiscount", "");
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.Branches = undefined;
    this.roles = undefined;
    this.DefaultValues = undefined;
  }
  setdefault() {
    if (this.model.UserName === "SepidzUser") {
      this.erroremessage = this.translate("ClientApp.GNR.User.EditingSepidzExpertUserProhibited");
      this.closeModal();
      this.sts.showToast(
        "control",
        this.translate("ClientApp.GNR.User.SepidzUser"),
        this.translate("ClientApp.GNR.User.EditingSepidzExpertUserProhibited"),
        3000
      );
    }
    if (!this.model.Branches) this.model.Branches = [];
    if (!this.model.Roles) this.model.Roles = [];
    if (this.isNewRow) {
      this.model.IsEnabled = true;

      ///به درخواست Ramez
      // this.model.NewPassword = "123456";
      // this.model.ConfirmPassword = "123456";
    }
    this.model.Roles.forEach((x) => {
      if (!this.roles.some((r) => r === x.ApplicationRoleId)) this.roles.push(x.ApplicationRoleId);
    });
    this.rolesIsLodes = true;
    if (!this.accountService.authService.currentBranch) {
      setTimeout(() => this.populateBranch(), 300);
    } else {
      this.populateBranch();
    }
  }
  setColumnAttribute() {
    this.orignalColumns.forEach((x) => {
      if (x.name.includes("Password")) {
        x.textType = "password";
      }
      if (x.name.includes("PasswordHash")) x.required = false;
      if (x.name.includes("NormalizedUserName")) x.required = false;
      if (x.name.includes("NormalizedDisplayName")) x.required = false;
      if (x.name.includes("SerialNumber")) x.required = false;
      if (this.accountService.authService.currentInformation().HasProtel) {
        if (x.name === "ProtelCode") x.formVisible = true;
      }
    });
    this.columns = this.orignalColumns.filter(
      (f) => ((!f.areaName || f.areaName === "default") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
    );
    this.Branches = this.getDetailControlModels("Branches");
    this.cd.markForCheck();
  }
  addControl() {
    this.setValue("RolesId", this.roles);
    this.setValue("ConfirmPassword", this.model.ConfirmPassword);
    this.setValue("NewPassword", this.model.NewPassword);
    this.setValue("PreventChangeClear", this.model.PreventChangeClear);
    this.setValue("SerialNumber", this.model.SerialNumber);
    this.setValue("rialDiscount", this.model.RialDiscount);
    this.setValue("percentDiscount", this.model.PercentDiscount);
    let validator: ValidatorFn[] = [];
    validator.push(Validators.minLength(3));
    validator.push(Validators.maxLength(128));
    this.formGroup.get("NewPassword").setValidators(validator);
    this.formGroup.get("ConfirmPassword").setValidators(validator);
    this.cd.markForCheck();
    this.formGroup
      ?.get("UserName")
      .valueChanges.pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((val) => {
        if (val !== this.formGroup.controls["DisplayName"].value && this.formGroup.dirty) {
          this.formGroup.controls["DisplayName"].setValue(val);
        }
      });
  }
  Discount() {
    if (this.formGroup.controls["percentDiscount"].value > 100) {
      this.setValue("percentDiscount", "100");
    }
  }
  populateBranch() {
    if (!this.model.Branches) this.model.Branches = [];
    this.isOk4View = false;
    if (this.accountService.authService.currentBranch.AccessToAllBranches) {
      this.isAccessToAllBranches = true;
      this.httpCommonService
        .getList("Branch/ReadLookUp")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data) => {
            (data as []).forEach((br: LookupItem) => {
              const b = this.model.Branches.find((x) => x.BranchId === br.Id);
              if (!b) {
                let entity = <UserBranch>{};
                entity.BranchId = br.Id;
                entity.BranchTitle = br.Title;
                entity.IsActive = true;
                entity.State = RowState.New;
                if (!this.model || !(this.model.Id > 0)) {
                  //اگر در مد ایجاد بودیم
                  entity.Selected = true;
                } else {
                  entity.Selected = false;
                }
                this.model.Branches.push(entity);
              } else b.Selected = true;
            });
            this.isOk4View = true;
            this.cd.markForCheck();
          },
          (error) => this.getFailedHelper(error)
        );
    } else {
      this.isAccessToAllBranches = false;
      this.httpCommonService
        .getItem("Branch/GetLookUpByBranchId", this.accountService.authService.currentBranchId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((data: LookupItem) => {
          if (!this.model.Branches) this.model.Branches = [];
          const itemBranch = this.model.Branches.find((x) => x.BranchId === data.Id);
          if (!itemBranch) {
            let entity = <UserBranch>{};
            entity.BranchId = data.Id;
            entity.BranchTitle = data.Title;
            entity.IsActive = true;
            entity.State = RowState.New;
            entity.Selected = true;
            this.model.Branches.push(entity);
          } else {
            this.model.Branches = [];
            itemBranch.Selected = true;
            this.model.Branches.push(itemBranch);
          }
          this.isOk4View = true;
          this.cd.markForCheck();
        });
    }
  }
  beforupdate() {
    this.model.RialDiscount = this.formGroup.controls["rialDiscount"].value;
    this.model.PercentDiscount = this.formGroup.controls["percentDiscount"].value;

    this.roles = this.formGroup.controls["RolesId"].value;

    this.model.Branches = this.model.Branches.filter((x) => x.Selected);
    if (this.model.Branches && this.model.Branches.length <= 0) this.model.Branches = null;

    this.model.Roles.forEach((x) => {
      if (!this.roles.some((r) => r === x.ApplicationRoleId)) x.State = RowState.Delete;
    });
    this.roles.forEach((x) => {
      if (!this.model.Roles.some((r) => r.ApplicationRoleId === x)) {
        let role: UserRole = <UserRole>{};
        role.ApplicationRoleId = x;
        role.ApplicationUserId = this.model.Id;
        role.State = RowState.New;
        this.model.Roles.push(role);
      }
    });
    this.setValue("Roles", this.model.Roles);
  }
  isValid(): boolean {
    if (this.erroremessage !== this.translate("ClientApp.GNR.User.InfoBranchCanNotDeleted")) this.erroremessage = undefined;
    this.haserror = false;
    if (this.formGroup.controls["NewPassword"].value) {
      let newPassword: string = this.formGroup.controls["NewPassword"].value;
      let confirmPass = this.formGroup.controls["ConfirmPassword"].value;
      if (!newPassword || !confirmPass) {
        this.haserror = true;
        this.erroremessage = this.translate("ClientApp.GNR.User.PasswordRequired");
      } else if (newPassword && !newPassword.trim()) {
        this.haserror = true;
        this.erroremessage = this.translate("ClientApp.GNR.User.PasswordNotContainOnlyHyphens");
      } else if (newPassword && confirmPass && newPassword !== confirmPass) {
        this.haserror = true;
        this.erroremessage = this.translate("ClientApp.GNR.User.CompareFaild");
      }
    }

    if (this.isNewRow) {
      if (!(this.model.Branches.filter((x) => x.Selected).length > 0)) {
        this.haserror = true;
        this.erroremessage = this.translate("ClientApp.GNR.Branch.DontHaveBranch");
      }
    } else if (!(this.model.Branches.filter((x) => x.Selected).length > 0)) {
      this.haserror = true;
      this.erroremessage = this.translate("ClientApp.GNR.Branch.DontHaveBranch");
    }
    return this.haserror ? this.haserror : !this.haserror;
  }
  onChanged($event) {
    if (this.haserror || this.model.Branches.filter((x) => x.Selected)[0]) {
      this.isValid();
    }
  }
  roleChanged() {
    setTimeout(() => this.cd.markForCheck(), 100);
  }
  async FillData() {
    if (
      this.accountService.authService.currentInformation().BranchingLightEnabled ||
      this.accountService.authService.currentInformation().BranchingAdvancedEnabled
    ) {
      this.httpCommonService
        .getList("UserLocalSetting/GetValidationBranch" + "/Security")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((hbc: CheckBrachAccessModel) => {
          if (hbc.TransferKindCode != 3) {
            if ((hbc.TransferKindCode == 2 || hbc.TransferKindCode == 5) && hbc.HasCommunication == true && hbc.BranchCount == 1) {
              this.sts.showDialog(this.translate("ClientApp.GNR.User.InfoBranchCanNotDeleted"), this.translate("ClientApp.GNR.User.Attention"));
              this.deactivateSave = true;
              return;
            } else {
              if ((hbc.TransferKindCode == 1 || hbc.TransferKindCode == 4) && hbc.BranchCount > 1) {
                this.sts.showDialog(
                  this.translate("ClientApp.GNR.User.InfoCentralOfficeCanNotDeleted"),
                  this.translate("ClientApp.GNR.User.Attention")
                );
                this.deactivateSave = true;
                return;
              }
            }
          }
        });
      (error) => this.getFailedHelper(error);
    }
  }
}
